import { Flex, Placement, PlacementArea, Text } from '@bitrise/bitkit';
import { useReferenceElement, VizContext } from '@bitrise/bitviz';
import React, { FunctionComponent, useContext } from 'react';
import { formatterMs } from '../../../utils/metric/getFormattedValue';
import { EventSeriesPoint } from './SessionEventsVisualisation';

interface Props {
  point: null | EventSeriesPoint;
}

const SessionEventsVisualisationTooltip: FunctionComponent<Props> = (props: Props) => {
  const { point } = props;
  const { xDomain } = useContext(VizContext);
  const referenceElement = useReferenceElement(point && { x: point.x, y: 0 });

  if (!referenceElement || !point) {
    return null;
  }

  return (
    <Placement
      backgroundColor="black"
      borderRadius="x1"
      placement="bottom"
      referenceElement={referenceElement}
      textColor="gray-1"
      visible
    >
      {() => (
        <PlacementArea paddingHorizontal="x3" paddingVertical="x2" withArrow>
          <Flex alignChildren="middle" direction="horizontal" gap="x2">
            <Flex>
              <Text config="8" weight="bold">
                {point.name}
              </Text>
            </Flex>

            <Flex>
              <Text config="8" textColor="gray-5">
                {formatterMs(point.x - xDomain[0])}
              </Text>
            </Flex>
          </Flex>
        </PlacementArea>
      )}
    </Placement>
  );
};

export default SessionEventsVisualisationTooltip;
